// http://keenthemes.com/preview/metronic/theme/admin_1/ui_colors.html

export default {
  // black: '#212121',

  blue: '#3598dc',
  blue_madison: '#578ebe',
  blue_chambray: '#2c3e50',
  blue_ebonyclay: '#22313f',
  blue_hoki: '#67809f',
  blue_steel: '#4b77be',
  blue_soft: '#4c87b9',
  blue_dark: '#5e738b',
  blue_sharp: '#5c9bd1',
  blue_oleo: '#94a0b2',

  green: '#32c5d2',
  green_meadow: '#1bbc9b',
  green_seagreen: '#1ba39c',
  green_turquoise: '#36d7b7',
  green_haze: '#44b6ae',
  green_jungle: '#26c281',
  green_soft: '#3faba4',
  green_dark: '#4db3a2',
  green_sharp: '#2ab4c0',
  green_steel: '#29b4b6',
  green_light: '#4caf50',

  grey: '#e5e5e5',
  grey_steel: '#e9edef',
  grey_cararra: '#fafafa',
  grey_gallery: '#555555',
  grey_cascade: '#95a5a6',
  grey_silver: '#bfbfbf',
  grey_salsa: '#acb5c3',
  grey_salt: '#bfcad1',
  grey_mint: '#525e64',

  red: '#e7505a',
  red_pink: '#e08283',
  red_sunglo: '#e26a6a',
  red_intense: '#e35b5a',
  red_thunderbird: '#d91e18',
  red_flamingo: '#ef4836',
  red_soft: '#d05454',
  red_haze: '#f36a5a',
  red_mint: '#e43a45',
  red_light: '#fc436a',

  pink: '#e91e63',
  pink_light: '#fc5578',

  yellow: '#c49f47',
  yellow_gold: '#e87e04',
  yellow_casablanca: '#f2784b',
  yellow_crusta: '#f3c200',
  yellow_lemon: '#f7ca18',
  yellow_saffron: '#f4d03f',
  yellow_soft: '#c8d046',
  yellow_haze: '#c5bf66',
  yellow_mint: '#c5b96b',
  yellow_light: '#ffc107',

  purple: '#8e44ad',
  purple_plum: '#8775a7',
  purple_medium: '#bf55ec',
  purple_studio: '#8e44ad',
  purple_wisteria: '#9b59b6',
  purple_seance: '#9a12b3',
  purple_intense: '#8775a7',
  purple_sharp: '#796799',
  purple_soft: '#8877a9',
};
